import styled, { css } from "styled-components";

export const Dot = styled.div`
  width: 14px;
  height: 14px;
  border-radius: ${({ theme }) => theme.br.circle};
  background: ${props => props.color};
  margin-right: 8px;
  margin-bottom: 1px;
  flex-shrink: 0;
`;

const dividerStyles = css`
  .nav-divider {
    opacity: 0.2;
    width: 85%;
    height: 1.5px;
    background-color: ${({ theme }) => theme.textLight};
  }
`;

export const panelNavStyles = css`
  ${dividerStyles}

  .nav-link {
    display: block;
    margin: 1px 8px 4px;
  }

  .nav-section {
    margin-bottom: 28px;

    .nav-link {
      margin: 1px 8px;
    }
  }

  .nav-item {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 36px;
    padding: 0 12px 0 14px;
    overflow: hidden;
    border-radius: ${({ theme }) => theme.br.md};
    color: ${({ theme }) => theme.textLight};
    font-family: ${({ theme }) => theme.p2r.ff};
    font-size: ${({ theme }) => theme.p2r.fs};
    transition: background-color 0.15s ease;
  }

  .nav-item-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .nav-item:hover {
    background-color: ${({ theme }) => theme.backgroundHover};
  }

  .active-nav-item .nav-item,
  .active-nav-item .nav-item:hover {
    background-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.textLight};
  }

  .open-nav-section .nav-item {
    background-color: ${({ theme }) => theme.backgroundHover};
    font-family: ${({ theme }) => theme.p2b.ff};
  }

  .nav-item-nested {
    color: ${({ theme }) => theme.textDark};
    font-size: 14px;
    font-family: ${({ theme }) => theme.p1r};
  }

  .active-nav-item .nav-dot {
    background: ${({ theme }) => theme.textLight};
  }

  .nav-add {
    color: ${({ theme }) => theme.primary};
    cursor: pointer;
  }

  .nav-divider {
    margin: 10px auto 14px;
  }
`;

export const popoverNavStyles = css`
  ${dividerStyles}

  .nav-item {
    display: flex;
    align-items: center;
    margin: 0 8px 2px;
    padding: 6px 14px;
    border-radius: ${({ theme }) => theme.br.md};
    transition: background-color 0.15s ease;
  }

  .nav-item-title {
    font-size: ${({ theme }) => theme.p3b.fs};
    font-family: ${({ theme }) => theme.p3b.ff};
    color: ${({ theme }) => theme.textLight};
    text-align: left;
  }

  .nav-item:hover {
    background-color: ${({ theme }) => theme.backgroundHover};
  }

  .active-nav-item .nav-item,
  .active-nav-item .nav-item:hover {
    background-color: ${({ theme }) => theme.primary};
  }

  .nav-divider {
    margin: 0 auto 10px;
    margin-top: -2px;
  }
`;
